// 校验11位手机号码
export const checkTelephone = (rule, value, callback) => {
  if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
    callback(new Error('请输入正确的手机号码'))
  } else {
    callback()
  }
}
